import { render, staticRenderFns } from "./GarageDeals.vue?vue&type=template&id=0ed3fcc0&scoped=true&"
import script from "./GarageDeals.vue?vue&type=script&lang=js&"
export * from "./GarageDeals.vue?vue&type=script&lang=js&"
import style0 from "./GarageDeals.vue?vue&type=style&index=0&id=0ed3fcc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed3fcc0",
  null
  
)

export default component.exports